'use strict';
import stringSimilarity from 'string-similarity';


angular.module('docketbook').
  controller('companySettingsUsersController', function (userService, $scope, Restangular, $state, $stateParams, $q, accessControl, Upload) {
    mixpanel.track("Opened CompanySettings-Users Desktop");
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentState = $state.current;
    $scope.logoLoading = false;
    $scope.allTimeFormats = ['12HR', '24HR'];
    $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };

    $scope.includedUsers

    $scope.allUsers = [];
    $scope.activeUsers = [];
    $scope.invitedUsers = [];
    $scope.allRoles = [];
    $scope.globalAdministrators = {};


    $scope.getMembers = function () {
      for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
        $scope.globalAdministrators[$scope.currentOrg.globalAdministrators[i]] = $scope.currentOrg.globalAdministrators[i];
      }
      return $q(function (resolve, reject) {
        userService.getMembers(null, function (users) {
          $scope.orgUsers = users;
          var globalAdminUsers = [];
          // go through currentOrg globalAdmins and populate names
          for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
            for (var j = 0; j < $scope.orgUsers.length; j++) {
              if ($scope.currentOrg.globalAdministrators[i] == $scope.orgUsers[j].id) {
                globalAdminUsers.push($scope.orgUsers[j]);
              }
            }
          }
          $scope.currentOrg.globalAdminUsers = globalAdminUsers;
          resolve()
        });
      })
    }

    $scope.getMembers()

    userService.getRoles(null, function (roles) {
      $scope.allRoles = roles;
    }, function (err) {
      $scope.allRoles = [];
    });

    $scope.loadAllUsers = function () {
      $scope.invitedUsers = [];
      $scope.activeUsers = [];

      userService.getMembers(null, function (users) {
        // get root group members to provide role details
        var rootGroupId = null;
        for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
          if ($scope.currentOrg.groups[i].parent == null) {
            rootGroupId = $scope.currentOrg.groups[i].id;
          }
        }
        userService.getOrganisationGroup(rootGroupId, function (groupFull) {

          $scope.allUsers = users;
          for (var i = 0; i < users.length; i++) {
            // check if this user is a global admin
            if ($scope.globalAdministrators[users[i].id]) {
              users[i].isGlobalAdmin = true;
            } else {
              users[i].isGlobalAdmin = false;
            }

            users[i].roles = [];

            for (var j = 0; j < groupFull.members.length; j++) {
              if (groupFull.members[j].user.id == users[i].id) {
                users[i].roles.push(groupFull.members[j].role);
              }
            }

            if (users[i].roles.length > 0) {
              users[i].roles[users[i].roles.length - 1].last = true;
            }

            if (users[i].invitationPending == true) {
              users[i].invitedGroupsString =
                $scope.currentOrg.groups
                  .map(group => {
                    const roles = group.members.filter(m => m.user == users[i].id).map(role => $scope.allRoles.find(r => r.id == role.role).name)
                    return { group: group.name, roles }
                  })
                  .filter(({ roles }) => roles.length > 0)
                  .map(({ group, roles }) => `${group} (${roles.join(', ')})`)
                  .join(', ')

              $scope.invitedUsers.push(users[i]);
            } else {
              $scope.activeUsers.push(users[i]);
            }
          }
        });
      }, function (err) {
        $scope.allUsers = [];
      });
    }

    $scope.uninviteMember = function (member) {

      var sortedGroups = _.sortBy($scope.currentOrg.groups, group => group.parent == null ? 0 : 1)
      var filteredGroups = sortedGroups.filter(group => group.members.map(member => member.user).includes(member.id))
      var groupsToRemove = filteredGroups.map(group => group.id)

      var failures = []

      const removeMembership = () => {
        if (groupsToRemove.length == 0) {
          if (failures.length == 0) {
            $scope.invitedUsers = $scope.invitedUsers.filter(user => user.id != member.id)
          } else {
            swal({
              title: "Oops!",
              text: "Sorry! An error occured while trying to remove the user",
              type: "error",
              confirmButtonText: "Ok, got it."
            })
          }
          return
        }

        const toRemove = groupsToRemove.pop()
        userService.removeMemberFromGroup(toRemove, member.id, removeMembership, err => {
          failures.push(err)
          removeMembership()
        })
      }

      removeMembership()
    }

    $scope.loadAllUsers();


    /******************/
    /* Invite Members */
    /******************/

    $scope.inviteNewMembers = function (group, type) {
      $("#inviteMembersModal").fadeIn(200);
      $scope.newMemberInvitesLoading = false;
      $scope.inviteMembers = {};
      if (type) {
        $scope.inviteMembers.type = type;
      } else {
        $scope.inviteMembers.type = 'member';
      }
      $scope.newMemberInvites = [{}];
    }



    // File Import
    $scope.file = null

    const mapping = {
      'first name': 'firstName',
      'last name': 'lastName',
      'contact': 'contact',
      'groups': 'groups',
      'role': 'role'
    }

    const reverseMapping = {}

    Object.keys(mapping)
      .forEach(key => {
        reverseMapping[mapping[key]] = key
      })


    const readTableHeaders = fileData => {
      const headers =
        fileData.shift()
          .map(header => header.toLowerCase())
          .map(header => {
            var found = null
            Object.keys(mapping).forEach(key => {
              if (header.includes(key)) {
                found = mapping[key]
                return
              }
            })
            return found
          })
          .filter(x => x !== null)

      const headerMissing = str => !headers.includes(str)

      const missing = Object.keys(reverseMapping).filter(headerMissing).map(header => reverseMapping[header])

      if (missing.length > 0) {
        swal({
          title: "Oops!",
          text: `The following columns are missing from the file: ${missing.join(', ')}`,
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return null
      }

      return fileData.map(data => {
        var item = {}
        headers.forEach((header, i) => {
          item[header] = data[i]
        })
        return item
      })
    }

    $scope.parseFile = function (fileToUpload) {
      $scope.importLoading = true;

      Upload.upload({
        url: '/v1/parse',
        data: { file: fileToUpload },
        withCredentials: true
      }).then(function (resp) {
        var data = readTableHeaders(resp.data[0].data)
        if (data == null) {
          $scope.importLoading = false;
          return
        }

        $scope.parseContactsForImport(data);
      }, function (resp) {
        $scope.importLoading = false;
        $scope.alertService.presentAutoAlert('readFile', resp);
      });
    }

    $scope.parseContactsForImport = function (data) {
      data.forEach(({ firstName, lastName, contact, groups, role }) => {
        contact = contact.trim().replace(/"/g, "").replace(/'/g, "")

        const groupsToAdd =
          $scope.currentOrg.groups.length == 1
            ? $scope.currentOrg.groups
            : groups && groups.toLowerCase() == 'all groups'
              ? $scope.currentOrg.groups
              : groups ? groups.split(',').map(name => name.trim()).map(groupName => {
                var potentialGroups =
                  $scope.currentOrg.groups
                    .map(group => ({
                      similarity: stringSimilarity.compareTwoStrings(group.name, groupName),
                      group
                    }))
                    .filter(x => x.similarity >= 0.7)

                return potentialGroups.length > 0 ? _.max(potentialGroups, x => x.similarity).group : null
              }).filter(group => group != null)
                : null


        const potentialRoles = role ?
          $scope.allRoles
            .map(checkRole => ({
              similarity: stringSimilarity.compareTwoStrings(checkRole.name, role),
              role: checkRole
            }))
            .filter(x => x.similarity >= 0.7)
          : null

        const roleToAdd = potentialRoles && potentialRoles.length > 0 ? _.max(potentialRoles, x => x.similarity).role : null

        $scope.newMemberInvites.push({ firstName, lastName, emailAddress: contact, groupsToAdd, role: roleToAdd })
      })
      $scope.importLoading = false;
      $scope.importFromFile = false
    }


    $scope.importNewMembers = function () {
      $scope.importFromFile = true
      $scope.inviteMembers = { type: 'member' }
      $scope.newMemberInvites = []
      $("#inviteMembersModal").fadeIn(200)
    }


    $scope.closeInviteMembers = function () {
      $("#inviteMembersModal").fadeOut(200);
      $scope.importFromFile = false;
    }

    $scope.addBlankInvitee = function () {
      $scope.newMemberInvites.push({});
    }

    $scope.removeInvitee = function (invitee) {
      $scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee), 1);
    }

    $scope.inviteMembersContinue = function () {
      $scope.newMemberInvitesLoading = true;
      var invitesArray = [];
      var invitesByGroup = {};
      for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
        invitesByGroup[$scope.currentOrg.groups[i].id] = [];
      }
      for (var i = 0; i < $scope.newMemberInvites.length; i++) {
        var roleAdd = $scope.newMemberInvites[i].role.id;
        var roles = [roleAdd];
        var groupsToAddTo = [];
        var addAllGroups = false;
        for (var j = 0; j < $scope.newMemberInvites[i].groupsToAdd.length; j++) {
          if ($scope.newMemberInvites[i].groupsToAdd[j].allGroups == true) {
            addAllGroups = true;
          }
          groupsToAddTo.push($scope.newMemberInvites[i].groupsToAdd[j].id);
        }
        if (addAllGroups == true) {
          groupsToAddTo = [];
          for (var j = 0; j < $scope.currentOrg.groups.length; j++) {
            groupsToAddTo.push($scope.currentOrg.groups[j].id);
          }
        }
        var newInvite = { 'emailAddress': $scope.newMemberInvites[i].emailAddress.replace(/\s/g, ''), 'roles': roles, 'firstName': $scope.newMemberInvites[i].firstName, 'lastName': $scope.newMemberInvites[i].lastName };
        for (var j = 0; j < groupsToAddTo.length; j++) {
          invitesByGroup[groupsToAddTo[j]].push(newInvite);
        }
      }


      userService.assignMembersToOrg(invitesByGroup, function (success) {
        $scope.loadAllUsers();
        $scope.closeInviteMembers();
      }, function (err) {
        $scope.newMemberInvitesLoading = false;
        $scope.alertService.presentAutoAlert('addGroupMembers', err);
      });
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/companySettings/users.js